import { useCallback } from 'react';
import { sdk } from 'sdk';
import { ProductQuery } from 'shared/types/query/ProductQuery';

const useProduct = () => {
  const queryProducts = useCallback(async (productQuery: ProductQuery) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.product.query(productQuery);

    return res;
  }, []);

  const queryExtraPageProducts = useCallback(async (productQuery: ProductQuery) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.product.queryWithExtraPageProducts(productQuery);
    return res;
  }, []);

  const getSearchTerms = useCallback(async (productQuery: { searchTerm: string; locale?: string }) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.product.getSearchTerms(productQuery);

    return res;
  }, []);

  const queryProductDiscounts = useCallback(async () => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.product.queryProductDiscounts();
    return res;
  }, []);

  return { query: queryProducts, getSearchTerms, queryExtraPageProducts, queryProductDiscounts };
};

export default useProduct;
